// The one address for wrong answers, topic requests and everything else —
// shared so it reads the same wherever it shows up (About, Profile, the legal
// pages) rather than drifting into three separate strings.
export const contactEmail = "quizfish@fastmail.com"

// The one "ask for a topic" line, under the topic grid on Home and on the
// Landing page — where the "no football?" thought happens. A mailto and
// nothing more: a request form would be a table nobody reads yet.
export function TopicRequestLine() {
	return (
		<p class="muted small">
			Missing a topic?{" "}
			<a href={`mailto:${contactEmail}?subject=Topic%20request`}>
				Tell me which
			</a>
			.
		</p>
	)
}

// The one footer line, shared by every document-shaped page (Home, Landing,
// About, the legal pages). It links home because the signed-out pages have no
// navbar above them.
export function SiteFooter() {
	return (
		<footer class="muted small text-center pt-3 border-top">
			<a href="/">Quizfish</a>
			{" · Built by "}
			<a href="https://sharats.me">Shri</a>
			{" · "}
			<a href="/about">About</a>
			{" · "}
			<a href="/privacy">Privacy</a>
			{" · "}
			<a href="/terms">Terms</a>
		</footer>
	)
}
